import StatusIndicator from './StatusIndicator.vue';
import CustomForm from './CustomForm/CustomForm.vue';
import FunctionBox from './FunctionBox.vue';
import Message from './messages/Message.vue';
import KeywordInput from './KeywordInput.vue';
import KeywordList from './KeywordList.vue';
import TagsList from './TagsList.vue';
import TimeAgo from './TimeAgo.vue';
import VideoPanel from './VideoPanel.vue';
import Image from './Image.vue';
import DocumentIcon from './icons/DocumentIcon.vue';
import LinkIcon from './icons/LinkIcon.vue';
import IntroductionComponent from './introduction/introduction.vue';
import TAndCComponent from './t-and-c/t-and-c.vue';
import PrechatComponent from './prechat-component/prechat-component.vue';
import PostchatComponent from './postchat-component/postchat-component.vue';

export default {
  StatusIndicator,
  CustomForm,
  FunctionBox,
  KeywordInput,
  KeywordList,
  Message,
  TagsList,
  TimeAgo,
  VideoPanel,
  Image,
  DocumentIcon,
  LinkIcon,
  IntroductionComponent,
  TAndCComponent,
  PrechatComponent,
  PostchatComponent,
};
